module.exports = __webpack_public_path__ + "static/media/resource-management.ce7c84aa.svg";